import { render, staticRenderFns } from "./CasinoSelect.vue?vue&type=template&id=24f6c972&scoped=true&"
import script from "./CasinoSelect.vue?vue&type=script&lang=js&"
export * from "./CasinoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6c972",
  null
  
)

export default component.exports